module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_8023.f6974f1a.png";